export const CREATE_TEAM = "CREATE_TEAM";
export const GET_TEAMS = "GET_TEAMS";
export const REMOVE_TEAMS = "REMOVE_TEAMS";
export const EDIT_TEAMS = "EDIT_TEAMS";
